module.exports = __webpack_public_path__ + "media/images/emblems/Nidau-coat_of_arms-efc05021b340a3d4052e5322338edec4.svg";